jQuery(document).ready(function () {

    var $ = jQuery.noConflict();

    let windowWidth = jQuery(window).width();

    if (windowWidth > 1199){
        desktopMenu();

        jQuery("[data-depth] li a").on('mouseenter', function(){
            let depth = jQuery(this).closest('ul[data-depth]').attr('data-depth');
            jQuery("[data-depth=" + parseInt(depth) + "]  li:not(.menu-ladder)").not(this).children('[data-depth="' + (parseInt(depth) + 1) + '"]').css('display','none');
            jQuery(this).closest('li').children('[data-depth="' + (parseInt(depth) + 1) + '"]').css('display', 'flex');

        });

        jQuery("[data-depth] li a").hover(function () {
            jQuery('ul[data-depth]').siblings('a').removeClass('active');
            jQuery(this).parents('ul[data-depth]').siblings('a').addClass('active');
        }, function () {

        });
    } else {
        mobileMenu();
        jQuery('.menu-item-has-children a').on('click', function (e) {
            e.stopPropagation();
        });
        jQuery('.menu-item-has-children').on('click', function(e){
            e.stopPropagation();
            console.log(jQuery(this));
            if (jQuery(this).closest('ul').hasClass('sub-depth-1')) {
                // jQuery(this).children('a').trigger('click');
                // jQuery(this).children('a').toggleClass('active');

            }
            if (jQuery(this).closest('ul').hasClass('sub-depth-0')){
                // jQuery(this).children('a').toggleClass('active');
            }
            jQuery(this).children('.sub-menu').toggleClass('sub-menu--open');
            jQuery(this).toggleClass('menu-item-has-children--open');
            console.log('show children');
        });
    }


    function desktopMenu(){
        jQuery('.sub-depth-0 li.links-normal').wrapAll("<li class='menu-ladder' />").wrapAll("<ul class='sub-menu-ladder' />");
    }

    function mobileMenu() {

        // jQuery('.sub-depth-0 li.links-normal').wrapAll("<li class='menu-ladder' />").wrapAll("<ul class='sub-menu-ladder' />");
    }


    jQuery('.header-content__hamburger').on('click', function () {
        console.log(windowWidth);
        jQuery('.header-content__nav').toggleClass('header-content__nav--show');
        jQuery('body').toggleClass('no-scroll');
    });

    jQuery('.nav-close').on('click', function () {
        console.log(windowWidth);
        jQuery('.header-content__nav').toggleClass('header-content__nav--show');
        jQuery('body').toggleClass('no-scroll');
    });

    // jQuery('window').on('resize', function(){
    //     windowWidth = jQuery('window').width();
    // });

});
